import { AliasToken } from 'antd/es/theme/interface/alias';
import { ComponentTokenMap } from 'antd/es/theme/interface/components';

export const Form: Partial<ComponentTokenMap['Form']> & Partial<AliasToken> = {
  fontSize: 12,
  lineHeight: 14 / 12,
};
